/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type LogInMutationInput = {
    readonly username: string;
    readonly password: string;
    readonly clientMutationId?: string | null;
};
export type LogInMutationVariables = {
    input: LogInMutationInput;
};
export type LogInMutationResponse = {
    readonly logIn: {
        readonly username: string | null;
        readonly token: string | null;
    } | null;
};
export type LogInMutation = {
    readonly response: LogInMutationResponse;
    readonly variables: LogInMutationVariables;
};



/*
mutation LogInMutation(
  $input: LogInMutationInput!
) {
  logIn(input: $input) {
    username
    token
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogInMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logIn",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogInMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogInMutation",
    "type": "RootMutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LogInMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogInMutation",
    "id": null,
    "text": "mutation LogInMutation(\n  $input: LogInMutationInput!\n) {\n  logIn(input: $input) {\n    username\n    token\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2760e91d7228e2d50f49b3ce695c3521';
export default node;
